module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "distanceXEdit"
    }
  }, [_vm._v("Delta X (can be negative)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.distanceX),
      expression: "value.distanceX"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "value": "50",
      "id": "distanceXEdit",
      "required": ""
    },
    domProps: {
      "value": (_vm.value.distanceX)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "distanceX", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-4"
  }, [_c('label', {
    attrs: {
      "for": "distanceYEdit"
    }
  }, [_vm._v("Delta Y (can be negative)")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.value.distanceY),
      expression: "value.distanceY"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "value": "50",
      "id": "distanceYEdit",
      "required": ""
    },
    domProps: {
      "value": (_vm.value.distanceY)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.value, "distanceY", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onExportClick
    }
  }, [_vm._v("Ok")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.onCancelClick
    }
  }, [_vm._v("Cancel")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-1ad81624", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ad81624"}!./~/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/components/distribute-diagram-nodes-dialog/distribute-diagram-nodes-dialog.vue.html
// module id = 1082
// module chunks = 0